import { makeStyles, createStyles } from '@material-ui/core/styles';

export default makeStyles(
  () =>
    createStyles({
      buttonItem: {
        display: 'flex',
        alignItems: 'flex-end',
      },
    }),
  { name: 'VinculoAssociadoPesquisa' }
);
